const translations = {
    addressTwoFieldLabel: 'Address Two'
};

export default translations;
